module.exports = __webpack_public_path__ + "static/media/check-box-checked.ec2f422a.svg";